export default __webpack_public_path__ + "static/media/Button Left.2c6c33b8.svg";